import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import PayaAddCardForm from "../../../../components/PayaAddCard/PayaAddCardForm";
import {
  LoaderComponent,
  WhiteLoaderComponent,
} from "../../../../components/Icon/Index";
import "../style.css";
import "../../Reports/style.css";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import {
  JobberPagination,
  JobberSearch,
  JobberSorting,
  JobberTable,
} from "../../../../components/MuiTable/index";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  FormControlLabel,
  Checkbox,
  Button as MuiButton,
} from "@mui/material";
import InputText from "../../../../components/InputFields/InputText";
import WhiteButton from "../../../../components/Button/WhiteButton";
import AddCardDetailsForm from "../../../../components/AdminViews/AddCardDetailsForm";
import DollerInput from "../../../../components/InputFields/Doller";
import CardImage from "../../../../assets/image/icons/CreditCard.png";
import CloseIcon from "@mui/icons-material/Close";
import AxiosInstance from "../../../AxiosInstance";
import showToast from "../../../../components/Toast/Toster";
import {
  getGatewayForPaymentMethod,
  isDejavooGateway,
} from "../../../../utils/gatewayHelper";

const RecurringPayments = ({
  loader,
  setPaymentOpen,
  search,
  setSearch,
  cellData,
  CollapseData,
  page,
  setRowsPerPage,
  countData,
  rowsPerPage,
  setPage,
  formik,
  paymentOpen,
  setSelectedAccountId,
  setSelectedFrequency,
  addBankAccountDialogOpen,
  setAddBankAccountDialogOpen,
  accountTypeName,
  AssetAccounts,
  toggles1,
  selectChargeDropDown,
  toggleWeekdayDropdown,
  weekdayDropdownOpen,
  toggleFrequencyDropdown,
  frequencyDropdownOpen,
  fetchAccounts,
  customerCards,
  selectCardDropDown,
  togglesCard,
  loading,
  isPublicKeyAvailable,
  setModalShow,
  modalShow,
  CustomerId,
  CompanyId,
  fetchRecurringCardData,
  submitloading,
  recurringChargeId,
  setRecurringChargeId,
  setSortField,
  setSortOrder,
  sortOrder,
  sortField,
  isDonationMode,
  transactionFeePercentage,
  applyTransactionFee,
  handleTransactionFeeChange,
  tokenDecode,
  submitAttempted,
  setSubmitAttempted,
  statusFilter,
  setStatusFilter,
}) => {
  const cardGateway = useMemo(
    () => getGatewayForPaymentMethod(tokenDecode, "Credit/debit card"),
    [tokenDecode]
  );
  const requiresSavedCard = !isDejavooGateway(cardGateway);
  const showAddCardOption =
    isPublicKeyAvailable ||
    isDejavooGateway(cardGateway) ||
    isDejavooGateway(tokenDecode?.Gateway);

  const initialValuesRef = useRef(null);
  const lastRecurringChargeIdRef = useRef(null);

  // Track initial values when editing
  useEffect(() => {
    if (recurringChargeId && paymentOpen) {
      const isNewEditSession = lastRecurringChargeIdRef.current !== recurringChargeId;
      
      if (isNewEditSession) {
        initialValuesRef.current = null;
        lastRecurringChargeIdRef.current = recurringChargeId;
      }

      if ((formik.values.amount || formik.values.frequency || formik.values.account_id) && !initialValuesRef.current) {
        initialValuesRef.current = {
          billing_id: formik.values.billing_id || "",
          card_type: formik.values.card_type || "",
          customer_vault_id: formik.values.customer_vault_id || "",
          cc_number: formik.values.cc_number || "",
          frequency: formik.values.frequency || "",
          frequency_interval: formik.values.frequency_interval || "",
          day_of_month: formik.values.day_of_month || "",
          weekday: formik.values.weekday || "",
          month: formik.values.month || "",
          day_of_year: formik.values.day_of_year || "",
          days_after_quarter: formik.values.days_after_quarter || "",
          account_id: formik.values.account_id || "",
          account_name: formik.values.account_name || "",
          amount: formik.values.amount || "",
          description: formik.values.description || "",
        };
      }
    } else if (!paymentOpen || !recurringChargeId) {
      initialValuesRef.current = null;
      if (!recurringChargeId) {
        lastRecurringChargeIdRef.current = null;
      }
    }
  }, [recurringChargeId, paymentOpen, formik.values.amount, formik.values.frequency, formik.values.account_id]);

  const hasFormChanges = () => {
    if (!recurringChargeId || !initialValuesRef.current) {
      return true; 
    }

    const current = {
      billing_id: formik.values.billing_id || "",
      card_type: formik.values.card_type || "",
      customer_vault_id: formik.values.customer_vault_id || "",
      cc_number: formik.values.cc_number || "",
      frequency: formik.values.frequency || "",
      frequency_interval: formik.values.frequency_interval || "",
      day_of_month: formik.values.day_of_month || "",
      weekday: formik.values.weekday || "",
      month: formik.values.month || "",
      day_of_year: formik.values.day_of_year || "",
      days_after_quarter: formik.values.days_after_quarter || "",
      account_id: formik.values.account_id || "",
      account_name: formik.values.account_name || "",
      amount: formik.values.amount || "",
      description: formik.values.description || "",
    };

    const initial = initialValuesRef.current;

    return (
      current.billing_id !== initial.billing_id ||
      current.card_type !== initial.card_type ||
      current.customer_vault_id !== initial.customer_vault_id ||
      current.cc_number !== initial.cc_number ||
      current.frequency !== initial.frequency ||
      current.frequency_interval !== initial.frequency_interval ||
      current.day_of_month !== initial.day_of_month ||
      current.weekday !== initial.weekday ||
      current.month !== initial.month ||
      current.day_of_year !== initial.day_of_year ||
      current.days_after_quarter !== initial.days_after_quarter ||
      current.account_id !== initial.account_id ||
      current.account_name !== initial.account_name ||
      current.amount !== initial.amount ||
      current.description !== initial.description
    );
  };

  return (
    <>
      <Grid className="justify-content-center align-items-center mb-3 mt-5 client">
        <Grid style={{ display: "flex", justifyContent: "end" }}>
          <Button
            className="border-donor-color bg-donor-color mb-3"
            onClick={() => setPaymentOpen({ isOpen: true, propertyData: null })}
          >
            Add Recurring Donation
          </Button>
        </Grid>

        <Grid>
          <Card
            className="donor-report-jobber-data-card"
            style={{
              borderRadius: "12px",
              border: "1px solid #E5E7EB",
              padding: 0,
              background: "#FFFFFF",
              boxShadow:
                "0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)",
              width: "100%",
            }}
          >
            <CardHeader
              className="d-flex justify-content-between align-items-center flex-wrap gap-2 table-header customerList_searchbar customersAddCustomers"
              style={{
                background: "#FFFFFF",
                borderBottom: "1px solid #E5E7EB",
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "16px 20px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: '"Poppins", "Inter", sans-serif',
                  fontWeight: 600,
                  fontSize: "18px",
                  color: "#1f2937",
                }}
              >
                Recurring Donation
              </Typography>
              <Grid
                className="customersearch d-flex customer_searchBar searchBarOfTable gap-2"
                style={{ flexWrap: "wrap", alignItems: "center" }}
              >
                <JobberSorting
                  triggerVariant="light"
                  dropdownItems={[
                    { text: "All" },
                    { text: "Active" },
                    { text: "Stopped" },
                  ]}
                  placeholder={statusFilter || "Status"}
                  value={statusFilter}
                  onSelect={(selectedLabel) => {
                    setStatusFilter(selectedLabel);
                    setPage(0);
                  }}
                />
                <JobberSearch search={search} setSearch={setSearch} />
              </Grid>
            </CardHeader>
            {loader ? (
              <Grid
                className="d-flex flex-direction-row justify-content-center align-items-center p-5 m-5"
                style={{
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <LoaderComponent isDonationMode={isDonationMode} height="50" width="50" loader={loader} />
              </Grid>
            ) : (
              <CardBody style={{ padding: "10px 0px" }}>
                <JobberTable
                  style={{ whiteSpace: "nowrap" }}
                  headerData={[
                    { label: "Cycle", field: "frequency" },
                    { label: "Account", field: "account_name" },
                    { label: "Card Number", field: "cc_number" },
                    { label: "Amount", field: "amount", align: "right" },
                    // { label: "Description", field: "description" },
                    { label: "Created At", field: "created" },
                    { label: "Next Due Date", field: "nextDueDate" },
                    { label: "Status", field: "status" },
                    { label: "Actions" },
                  ]}
                  setSortField={setSortField}
                  setSortOrder={setSortOrder}
                  sortOrder={sortOrder}
                  sortField={sortField}
                  cellData={cellData}
                  isCollapse={true}
                  page={page}
                  CollapseComponent={(data) => CollapseData(data)}
                  isNavigate={true}
                />
              </CardBody>
            )}
            <CardFooter
              className="jobber-list-card__footer donor-report-jobber-table-footer"
              style={{
                background: "#FFFFFF",
                borderTop: "1px solid #E5E7EB",
                borderBottomLeftRadius: "12px",
                borderBottomRightRadius: "12px",
                padding: "12px 16px",
              }}
            >
              <JobberPagination
                donorManagerShell={false}
                totalData={countData}
                currentData={rowsPerPage}
                dataPerPage={rowsPerPage}
                pageItems={[10, 25, 50]}
                page={page}
                setPage={setPage}
                setRowsPerPage={setRowsPerPage}
              />
            </CardFooter>
          </Card>
        </Grid>
      </Grid>
      <Dialog
        fullWidth
        open={paymentOpen}
        onClose={() => {
          setPaymentOpen(false);
          formik.resetForm();
          setSelectedAccountId("");
          setSelectedFrequency("");
          setRecurringChargeId(null);
          setSubmitAttempted(false);
        }}
        addBankAccountDialogOpen={addBankAccountDialogOpen}
        setAddBankAccountDialogOpen={setAddBankAccountDialogOpen}
        accountTypeName={accountTypeName}
        fetchAccounts={fetchAccounts}
        PaperProps={{
          style: {
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "var(--shadow-lg)",
          },
        }}
      >
        <DialogTitle
          className="text-donor-color border-donor-color"
          style={{
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          {recurringChargeId ? "Update Recurring Donation" : "Add Recurring Donation"}
        </DialogTitle>
        {loading ? (
          <Grid
            className="d-flex flex-direction-row justify-content-center align-items-center Typography-5 m-5"
            style={{ height: "80vh", marginTop: "25%" }}
          >
            <LoaderComponent isDonationMode={true} loader={loading} height="50" width="50" />
          </Grid>
        ) : (
          <DialogContent
            className="border-green-color"
            dividers
            sx={{
              padding: { xs: "16px 20px", sm: "20px 24px" },
              borderTop: "4px solid ",
            }}
          >
            <Grid>
              <Grid>
                {/* Show card selection dropdown for other gateways */}
                <>
                    <Dropdown
                      className="mb-3"
                      isOpen={selectCardDropDown}
                      toggle={() => {
                        const wasOpen = selectCardDropDown;
                        togglesCard();
                        // Set touched when dropdown closes if no value selected
                        if (wasOpen && requiresSavedCard && (!formik?.values?.billing_id || formik?.values?.billing_id === "")) {
                          setTimeout(() => {
                            formik.setFieldTouched("billing_id", true);
                          }, 0);
                        }
                      }}
                    >
                      {(() => {
                        const hasCardError =
                          (submitAttempted || formik?.touched?.billing_id) &&
                          (!formik?.values?.billing_id ||
                            formik?.values?.billing_id === "") &&
                          requiresSavedCard;
                        const hasValue = formik?.values?.billing_id && formik?.values?.cc_number;
                        return (
                          <DropdownToggle
                            className={`${hasCardError ? "" : "border-blue-color text-blue-color"}`}
                            caret
                            style={{
                              width: "100%",
                              border: "1px solid",
                              borderColor: hasCardError ? "#dc3545" : "#0f2b46",
                              color: hasCardError ? "#dc3545" : "#0f2b46",
                              backgroundColor: "transparent",
                              height: "50px",
                              textAlign: "start",
                              display: "flex",
                              alignItems: "center",
                              position: "relative",
                              paddingRight: "12px",
                            }}
                          >
                            <span style={{ display: "flex", alignItems: "center", flex: 1, overflow: "hidden", minWidth: 0, paddingRight: hasValue ? "30px" : "0" }}>
                              {hasValue ? (
                                <>
                                  <img
                                    src={
                                      customerCards.find(
                                        (card) => card?.billing_id === formik?.values?.billing_id
                                      )?.card_logo
                                      || customerCards.find(
                                        (card) => card?.billing_id === formik?.values?.billing_id
                                      )?.image
                                      || CardImage
                                    }
                                    alt="Card Logo"
                                    style={{ width: "24px", marginRight: "10px", flexShrink: 0 }}
                                    onError={(e) => {
                                      e.target.src = CardImage;
                                    }}
                                  />
                                  <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {`${formik?.values?.card_type} ${formik?.values?.cc_number}`}
                                  </span>
                                </>
                              ) : (
                                "Select Card"
                              )}
                            </span>
                            {hasValue && (
                              <CloseIcon
                                style={{
                                  fontSize: "18px",
                                  cursor: "pointer",
                                  position: "absolute",
                                  right: "28px",
                                  zIndex: 1,
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  formik.setFieldValue("billing_id", "");
                                  formik.setFieldValue("card_type", "");
                                  formik.setFieldValue("customer_vault_id", "");
                                  formik.setFieldValue("cc_number", "");
                                  formik.setFieldTouched("billing_id", false);
                                  formik.setFieldError("billing_id", undefined);
                                }}
                              />
                            )}
                          </DropdownToggle>
                        );
                      })()}

                      <DropdownMenu
                        className="dropdownfontsyle border-blue-color"
                        style={{
                          width: "100%",
                          maxHeight: "200px",
                          overflowY: "auto",
                          boxShadow: "var(--shadow-md)",
                          border: "none",
                        }}
                      >
                        {!tokenDecode ? (
                          <DropdownItem disabled>Loading company data...</DropdownItem>
                        ) : !(cardGateway || tokenDecode?.Gateway) ? (
                          <DropdownItem disabled>No payment gateway configured</DropdownItem>
                        ) : cardGateway === "PAYA" ? (
                          <PayaAddCardForm
                            onSuccess={(cardData) => {
                              formik.setFieldValue("billing_id", cardData.billing_id);
                              formik.setFieldValue("card_type", cardData.card_type);
                              formik.setFieldValue("customer_vault_id", cardData.customer_vault_id);
                              formik.setFieldValue("cc_number", cardData.cc_number);
                              formik.setFieldValue("Gateway", "PAYA");
                            }}
                            onCancel={() => {
                              // Handle cancel
                            }}
                            CustomerId={CustomerId}
                            CompanyId={CompanyId}
                          />
                        ) : (
                          <>
                            {customerCards?.length > 0 ? (
                              <>
                                <DropdownItem
                                  className="fontstylerentmodal text-blue-color"
                                  header
                                  style={{ fontWeight: "600" }}
                                >
                                  Select a Card
                                </DropdownItem>
                                {showAddCardOption && (
                                  <DropdownItem
                                    className="background-colorsty bgtextwhite"
                                    onClick={() => setModalShow(true)}
                                  >
                                    Add Card
                                  </DropdownItem>
                                )}
                                {customerCards?.map((item) => (
                                  <DropdownItem
                                    key={item.billing_id}
                                    onClick={() => {
                                      formik.setFieldValue(
                                        "billing_id",
                                        item.billing_id
                                      );
                                      formik.setFieldValue(
                                        "card_type",
                                        item?.card_type
                                      );
                                      formik.setFieldValue(
                                        "customer_vault_id",
                                        item.customer_vault_id
                                      );
                                      formik.setFieldValue(
                                        "cc_number",
                                        item?.cc_number
                                      );
                                      formik.setFieldTouched("billing_id", true);
                                      if (item?.billing_id) {
                                        formik.setFieldError("billing_id", undefined);
                                      }
                                    }}
                                    style={{ display: "flex", alignItems: "center" }}
                                  >
                                   <img
                                      src={item?.card_logo || item?.image || CardImage}
                                      alt={item?.cc_type || item?.cardType || "Card"}
                                      style={{ width: "24px", marginRight: "10px" }}
                                      onError={(e) => {
                                        e.target.src = CardImage;
                                      }}
                                    />
                                    {`${item?.cc_type} ${item?.cc_number}`}
                                  </DropdownItem>
                                ))}
                              </>
                            ) : (
                              <>
                                {showAddCardOption && (
                                  <DropdownItem
                                    key="add-card"
                                    className="background-colorsty bgtextwhite"
                                    onClick={() => setModalShow(true)}
                                  >
                                    Add Card
                                  </DropdownItem>
                                )}
                                <DropdownItem key="no-cards" disabled>
                                  No Cards Available
                                </DropdownItem>
                              </>
                            )}
                          </>
                        )}
                      </DropdownMenu>
                    </Dropdown>

                  </>
                {(() => {
                  const hasFrequencyError = (submitAttempted || formik?.touched?.frequency) && (!formik?.values?.frequency || formik?.values?.frequency === "");
                  const hasValue = formik?.values?.frequency && formik?.values?.frequency !== "";
                  return (
                    <Dropdown
                      className="mb-3"
                      isOpen={frequencyDropdownOpen}
                      toggle={() => {
                        const wasOpen = frequencyDropdownOpen;
                        toggleFrequencyDropdown();
                        // Set touched when dropdown closes if no value selected
                        if (wasOpen && (!formik?.values?.frequency || formik?.values?.frequency === "")) {
                          setTimeout(() => {
                            formik.setFieldTouched("frequency", true);
                          }, 0);
                        }
                      }}
                    >
                      <DropdownToggle
                        className={`${hasFrequencyError ? "" : "border-blue-color text-blue-color"}`}
                        caret
                        style={{
                          width: "100%",
                          border: "1px solid",
                          borderColor: hasFrequencyError ? "#dc3545" : "#0f2b46",
                          color: hasFrequencyError ? "#dc3545" : "#0f2b46",
                          backgroundColor: "transparent",
                          height: "50px",
                          textAlign: "start",
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                          paddingRight: "12px",
                        }}
                      >
                        <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0, paddingRight: hasValue ? "30px" : "0" }}>
                          {formik?.values?.frequency || "Select Frequency *"}
                        </span>
                        {hasValue && (
                          <CloseIcon
                            style={{
                              fontSize: "18px",
                              cursor: "pointer",
                              position: "absolute",
                              right: "28px",
                              zIndex: 1,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              formik.setFieldValue("frequency", "");
                              formik.setFieldValue("frequency_interval", "");
                              formik.setFieldValue("day_of_month", "");
                              formik.setFieldValue("weekday", "");
                              formik.setFieldValue("month", "");
                              formik.setFieldValue("day_of_year", "");
                              formik.setFieldValue("days_after_quarter", "");
                              formik.setFieldTouched("frequency", false);
                              formik.setFieldError("frequency", undefined);
                            }}
                          />
                        )}
                      </DropdownToggle>
                  <DropdownMenu
                    className="dropdownfontsyle"
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      overflowY: "auto",
                      boxShadow: "var(--shadow-md)",
                      border: "none",
                    }}
                    name="frequency"
                  >
                    {[
                      "Yearly",
                      "Monthly",
                      "Every N Months",
                      "Weekly",
                      "Every N Weeks",
                      "Quarterly",
                    ].map((option) => (
                      <DropdownItem
                        key={option}
                        onClick={() => {
                          formik.setFieldValue("frequency", option);
                          formik.setFieldValue("frequency_interval", "");
                          formik.setFieldTouched("frequency", true);
                          if (option) {
                            formik.setFieldError("frequency", undefined);
                          }
                        }}
                      >
                        {option}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                    </Dropdown>
                  );
                })()}


                {(formik?.values?.frequency === "Every N Months" ||
                  formik?.values?.frequency === "Every N Weeks") && (
                  <>
                    <InputText
                      className="mb-3 border-blue-color text-blue-color"
                      type="number"
                      name="frequency_interval"
                      value={formik?.values?.frequency_interval}
                      onChange={(e) => {
                        let value = parseInt(e.target.value, 10) || "";
                        let maxValue =
                          formik?.values?.frequency === "Every N Months" ? 12 : 4;
                        if (value > maxValue) value = maxValue;
                        if (value < 1) value = 1;
                        formik.setFieldValue("frequency_interval", value);
                        // Clear error in real-time when valid data is entered
                        if (value && value >= 1) {
                          formik.setFieldError("frequency_interval", undefined);
                        }
                      }}
                      onBlur={() => {
                        formik.setFieldTouched("frequency_interval", true);
                      }}
                      placeholder="Enter interval"
                      style={{ width: "100%" }}
                      label="Enter interval *"
                      error={
                        (submitAttempted || formik?.touched?.frequency_interval) && (!formik?.values?.frequency_interval || formik?.values?.frequency_interval === "" || Boolean(formik?.errors?.frequency_interval))
                      }
                      helperText={undefined}
                      showErrorOnly={true}
                    />
                  </>
                )}

                {(formik?.values?.frequency === "Monthly" ||
                  formik?.values?.frequency === "Every N Months") && (
                  <>
                    <InputText
                      className="mb-3 border-blue-color text-blue-color"
                      type="number"
                      name="day_of_month"
                      value={formik?.values?.day_of_month}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || (value >= 1 && value <= 28)) {
                          formik.setFieldValue("day_of_month", value);
                          // Clear error in real-time when valid data is entered
                          if (value && parseInt(value, 10) >= 1 && parseInt(value, 10) <= 28) {
                            formik.setFieldError("day_of_month", undefined);
                          }
                        }
                      }}
                      onBlur={() => {
                        formik.setFieldTouched("day_of_month", true);
                      }}
                      placeholder="Enter day of the month(1-28)"
                      min="1"
                      max="28"
                      style={{ width: "100%" }}
                      label="Enter day of month *"
                      error={
                        (submitAttempted || formik?.touched?.day_of_month) && (!formik?.values?.day_of_month || formik?.values?.day_of_month === "" || Boolean(formik?.errors?.day_of_month))
                      }
                      helperText={undefined}
                      showErrorOnly={true}
                    />
                  </>
                )}

                {(formik?.values?.frequency === "Every N Weeks" ||
                  formik?.values?.frequency === "Weekly") && (
                  <>
                    {(() => {
                      const hasWeekdayError = (submitAttempted || formik?.touched?.weekday) && (!formik?.values?.weekday || formik?.values?.weekday === "");
                      return (
                        <Dropdown
                          className="mb-3"
                          isOpen={weekdayDropdownOpen}
                          toggle={() => {
                            const wasOpen = weekdayDropdownOpen;
                            toggleWeekdayDropdown();
                            // Set touched when dropdown closes if no value selected
                            if (wasOpen && (!formik?.values?.weekday || formik?.values?.weekday === "")) {
                              setTimeout(() => {
                                formik.setFieldTouched("weekday", true);
                              }, 0);
                            }
                          }}
                        >
                          <DropdownToggle
                            className={`text-blue-color ${hasWeekdayError ? "" : "border-blue-color"}`}
                            caret
                            style={{
                              width: "100%",
                              border: "1px solid",
                              borderColor: hasWeekdayError ? "#dc3545" : "#0f2b46",
                              backgroundColor: "transparent",
                              height: "50px",
                              textAlign: "start",
                            }}
                          >
                            {formik?.values?.weekday || "Select Day of the Week *"}
                          </DropdownToggle>
                      <DropdownMenu
                        className="dropdownfontsyle"
                        style={{
                          width: "100%",
                          maxHeight: "200px",
                          overflowY: "auto",
                          boxShadow: "var(--shadow-md)",
                          border: "none",
                        }}
                      >
                        {[
                          "Sunday",
                          "Monday",
                          "Tuesday",
                          "Wednesday",
                          "Thursday",
                          "Friday",
                          "Saturday",
                        ].map((day) => (
                          <DropdownItem
                            key={day}
                            onClick={() => {
                              formik.setFieldValue("weekday", day);
                              formik.setFieldTouched("weekday", true);
                              if (day) {
                                formik.setFieldError("weekday", undefined);
                              }
                            }}
                          >
                            {day}
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                        </Dropdown>
                      );
                    })()}
                  </>
                )}

                {formik?.values?.frequency === "Yearly" && (
                  <>
                    <Grid>
                      <InputText
                        type="number"
                        name="day_of_year"
                        value={formik?.values?.day_of_year || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "" || (value >= 1 && value <= 28)) {
                            formik.setFieldValue("day_of_year", value);
                            // Clear error in real-time when valid data is entered
                            if (value && parseInt(value, 10) >= 1 && parseInt(value, 10) <= 28) {
                              formik.setFieldError("day_of_year", undefined);
                            }
                          }
                        }}
                        onBlur={() => {
                          formik.setFieldTouched("day_of_year", true);
                        }}
                        placeholder="Enter day"
                        min="1"
                        max="28"
                        style={{ width: "100%" }}
                        label="Enter day *"
                        error={
                          (submitAttempted || formik?.touched?.day_of_year) && (!formik?.values?.day_of_year || formik?.values?.day_of_year === "" || Boolean(formik?.errors?.day_of_year))
                        }
                        helperText={undefined}
                        showErrorOnly={true}
                      />
                    </Grid>
                    <Grid>
                      <InputText
                        className="mt-3"
                        type="number"
                        name="month"
                        value={formik?.values?.month || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "" || (value >= 1 && value <= 12)) {
                            formik.setFieldValue("month", value);
                            // Clear error in real-time when valid data is entered
                            if (value && parseInt(value, 10) >= 1 && parseInt(value, 10) <= 12) {
                              formik.setFieldError("month", undefined);
                            }
                          }
                        }}
                        onBlur={() => {
                          formik.setFieldTouched("month", true);
                        }}
                        placeholder="Enter month (1-12)"
                        min="1"
                        max="12"
                        style={{
                          width: "100%",
                          mrginTop: "10px",
                          marginBottom: "10px ",
                        }}
                        label="Enter month *"
                        error={
                          (submitAttempted || formik?.touched?.month) && (!formik?.values?.month || formik?.values?.month === "" || Boolean(formik?.errors?.month))
                        }
                        helperText={undefined}
                        showErrorOnly={true}
                      />
                    </Grid>
                  </>
                )}

                {formik?.values?.frequency === "Quarterly" && (
                  <>
                    <InputText
                      type="number"
                      name="days_after_quarter"
                      value={formik?.values?.days_after_quarter || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || (value >= 0 && value <= 90)) {
                          formik.setFieldValue("days_after_quarter", value);
                          // Clear error in real-time when valid data is entered
                          if (value !== "" && value !== null && value !== undefined && parseInt(value, 10) >= 0 && parseInt(value, 10) <= 90) {
                            formik.setFieldError("days_after_quarter", undefined);
                          }
                        }
                      }}
                      onBlur={() => {
                        formik.setFieldTouched("days_after_quarter", true);
                      }}
                      placeholder="Enter days after quarter start"
                      min="0"
                      max="90"
                      className="pb-3"
                      style={{ width: "100%" }}
                      label="Enter days after quarter start *"
                      error={
                        (submitAttempted || formik?.touched?.days_after_quarter) && (formik?.values?.days_after_quarter === "" || formik?.values?.days_after_quarter === null || formik?.values?.days_after_quarter === undefined || Boolean(formik?.errors?.days_after_quarter))
                      }
                      helperText={undefined}
                      showErrorOnly={true}
                    />
                  </>
                )}
              </Grid>

              {(() => {
                const hasAccountError = (submitAttempted || formik?.touched?.account_id) && (!formik?.values?.account_id || formik?.values?.account_id === "");
                const hasValue = formik?.values?.account_id && formik?.values?.account_name;
                return (
                  <Dropdown
                    className="mb-3"
                    isOpen={selectChargeDropDown}
                    toggle={() => {
                      const wasOpen = selectChargeDropDown;
                      toggles1();
                      // Set touched when dropdown closes if no value selected
                      if (wasOpen && (!formik?.values?.account_id || formik?.values?.account_id === "")) {
                        setTimeout(() => {
                          formik.setFieldTouched("account_id", true);
                        }, 0);
                      }
                    }}
                  >
                    <DropdownToggle
                      className={`${hasAccountError ? "" : "border-blue-color text-blue-color"}`}
                      caret
                      style={{
                        width: "100%",
                        border: "1px solid",
                        borderColor: hasAccountError ? "#dc3545" : "#0f2b46",
                        color: hasAccountError ? "#dc3545" : "#0f2b46",
                        backgroundColor: "transparent",
                        height: "50px",
                        textAlign: "start",
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                        paddingRight: "12px",
                      }}
                    >
                      <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0, paddingRight: hasValue ? "30px" : "0" }}>
                        {formik?.values?.account_name || "Select Account *"}
                      </span>
                      {hasValue && (
                        <CloseIcon
                          style={{
                            fontSize: "18px",
                            cursor: "pointer",
                            position: "absolute",
                            right: "28px",
                            zIndex: 1,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            formik.setFieldValue("account_id", "");
                            formik.setFieldValue("account_name", "");
                            formik.setFieldTouched("account_id", false);
                            formik.setFieldError("account_id", undefined);
                          }}
                        />
                      )}
                    </DropdownToggle>
                <DropdownMenu
                  className="dropdownfontsyle"
                  style={{
                    width: "100%",
                    maxHeight: "200px",
                    boxShadow: "var(--shadow-md)",
                    overflowY: "auto",
                    border: "none",
                  }}
                >
                  {AssetAccounts?.length > 0 ? (
                    <>
                      <DropdownItem
                        className="fontstylerentmodal text-blue-color"
                        header
                        style={{
                          fontWeight: "600",
                        }}
                      >
                        Asset
                      </DropdownItem>
                      {AssetAccounts?.map((item) => (
                        <DropdownItem
                          key={item?.account_id}
                          onClick={() => {
                            formik.setFieldValue("account_id", item?.account_id);
                            formik.setFieldValue(
                              "account_name",
                              item?.account_name
                            );
                            formik.setFieldTouched("account_id", true);
                            if (item?.account_id) {
                              formik.setFieldError("account_id", undefined);
                            }
                          }}
                        >
                          <Grid
                            style={{
                              position: "relative",
                              display: "inline-block",
                              width: "100%",
                            }}
                          >
                            <Grid
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "150px",
                                cursor: "pointer",
                                position: "relative",
                              }}
                              title={item?.account_name || "Account Name not available"}
                            >
                              {item?.account_name ||
                                "Account Name not available"}
                            </Grid>
                          </Grid>
                        </DropdownItem>
                      ))}
                      <DropdownItem
                        className="background-colorsty bgtextwhite"
                        onClick={() => {
                          setAddBankAccountDialogOpen(true);
                          toggles1();
                        }}
                        style={{
                          marginTop: "8px",
                          fontWeight: "600",
                          color: "#0f2b46",
                        }}
                      >
                        + Add Account
                      </DropdownItem>
                    </>
                  ) : (
                    <>
                      <DropdownItem
                        className="background-colorsty bgtextwhite"
                        onClick={() => {
                          setAddBankAccountDialogOpen(true);
                          toggles1();
                        }}
                        style={{
                          fontWeight: "600",
                          color: "#0f2b46",
                        }}
                      >
                        + Add Account
                      </DropdownItem>
                      <DropdownItem disabled>
                        No Accounts Available
                      </DropdownItem>
                    </>
                  )}
                </DropdownMenu>
                  </Dropdown>
                );
              })()}

              <Grid>
                <Grid>
                  <DollerInput
                    placeholder="Enter Amount"
                    value={formik?.values?.amount}
                    onChange={(e) => {
                      let rawValue = e.target.value.replace(/[^0-9.]/g, "");

                      if ((rawValue.match(/\./g) || []).length > 1) {
                        rawValue = rawValue.slice(0, rawValue.lastIndexOf("."));
                      }

                      formik.setFieldValue("amount", rawValue);
                      // Clear error in real-time when valid data is entered
                      if (rawValue && parseFloat(rawValue) > 0) {
                        formik.setFieldError("amount", undefined);
                      }
                    }}
                    onBlur={() => {
                      let finalValue = parseFloat(
                        formik?.values?.amount || "0"
                      ).toFixed(2);
                      formik.setFieldValue("amount", finalValue);
                      formik.setFieldTouched("amount", true);
                    }}
                    error={
                      (submitAttempted || formik?.touched?.amount) && (!formik?.values?.amount || formik?.values?.amount === "" || parseFloat(formik?.values?.amount || "0") <= 0 || Boolean(formik?.errors?.amount))
                    }
                    helperText={undefined}
                    showErrorOnly={true}
                    name="amount"
                    label="Amount *"
                    type="text"
                  />
                </Grid>
              </Grid>
              <Grid>
                <InputText
                  className="note-details mt-1 text-blue-color border-blue-color"
                  name="description"
                  label="Description"
                  type="text"
                  value={formik?.values?.description}
                  onChange={formik.handleChange}
                  placeholder="Enter A description"
                  multiline
                  rows={3}
                />
              </Grid>

              {/* General Error Message */}
              {submitAttempted && Boolean(
                (requiresSavedCard && (!formik?.values?.billing_id || formik?.values?.billing_id === "")) ||
                (!formik?.values?.frequency || formik?.values?.frequency === "") ||
                (!formik?.values?.account_id || formik?.values?.account_id === "") ||
                (!formik?.values?.amount || formik?.values?.amount === "" || parseFloat(formik?.values?.amount || "0") <= 0) ||
                (formik?.values?.frequency === "Every N Months" && (!formik?.values?.frequency_interval || formik?.values?.frequency_interval === "")) ||
                (formik?.values?.frequency === "Every N Weeks" && (!formik?.values?.frequency_interval || formik?.values?.frequency_interval === "")) ||
                ((formik?.values?.frequency === "Monthly" || formik?.values?.frequency === "Every N Months") && (!formik?.values?.day_of_month || formik?.values?.day_of_month === "")) ||
                ((formik?.values?.frequency === "Weekly" || formik?.values?.frequency === "Every N Weeks") && (!formik?.values?.weekday || formik?.values?.weekday === "")) ||
                (formik?.values?.frequency === "Yearly" && (!formik?.values?.day_of_year || formik?.values?.day_of_year === "" || !formik?.values?.month || formik?.values?.month === "")) ||
                (formik?.values?.frequency === "Quarterly" && (formik?.values?.days_after_quarter === "" || formik?.values?.days_after_quarter === null || formik?.values?.days_after_quarter === undefined))
              ) && (
                <Grid
                  sx={{
                    mt: 2,
                    mb: 2,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#dc3545",
                      fontSize: "14px",
                      fontWeight: 500,
                      textAlign: "center",
                    }}
                  >
                    Please correct the red boxes above
                  </Typography>
                </Grid>
              )}
              <Grid>
                {isDonationMode && transactionFeePercentage > 0 && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={applyTransactionFee}
                        onChange={handleTransactionFeeChange}
                        sx={{
                          color: "#0f2b46",
                          "&.Mui-checked": {
                            color: "#0f2b46",
                          },
                        }}
                      />
                    }
                    label={
                      <span>
                        Would you like to cover the{" "}
                        <strong>{transactionFeePercentage}%</strong> transaction
                        fee along with donation?
                      </span>
                    }
                    sx={{ marginTop: "8px", color: "#0f2b46" }}
                  />
                )}
              </Grid>
            </Grid>
            <Grid className="mt-3 d-flex justify-content-between chargeModelBt">
              <WhiteButton
                className="text-blue-color border-blue-color nogoback"
                onClick={() => {
                  formik.resetForm();
                  setPaymentOpen(false);
                  setRecurringChargeId(null);
                  setSubmitAttempted(false);
                }}
                label="Cancel"
              />
              {loading ? (
                <WhiteLoaderComponent
                  height="20"
                  width="20"
                  padding="20"
                  loader={loading}
                />
              ) : (
                <Grid className="gap-3 d-flex  ">
                  <Button
                    className="border-donor-color bg-donor-color"
                    onClick={() => {
                      setSubmitAttempted(true);
                      let hasErrors = false;
                      if (requiresSavedCard) {
                        formik.setFieldTouched("billing_id", true);
                        if (!String(formik.values.billing_id ?? "").trim()) {
                          formik.setFieldError("billing_id", "Please select a card");
                          hasErrors = true;
                        }
                      }

                      // Validate frequency
                      formik.setFieldTouched("frequency", true);
                      if (!formik.values.frequency) {
                        formik.setFieldError("frequency", "Frequency is required");
                        hasErrors = true;
                      }

                      // Validate account
                      formik.setFieldTouched("account_id", true);
                      if (!formik.values.account_id) {
                        formik.setFieldError("account_id", "Account is required");
                        hasErrors = true;
                      }

                      // Validate amount
                      formik.setFieldTouched("amount", true);
                      if (!formik.values.amount || parseFloat(formik.values.amount || "0") <= 0) {
                        formik.setFieldError("amount", "Amount is required and must be greater than 0");
                        hasErrors = true;
                      }

                      // Validate frequency-specific fields
                      if (formik.values.frequency === "Every N Months" || formik.values.frequency === "Every N Weeks") {
                        formik.setFieldTouched("frequency_interval", true);
                        if (!formik.values.frequency_interval) {
                          formik.setFieldError("frequency_interval", "Frequency interval is required");
                          hasErrors = true;
                        }
                      }

                      if (formik.values.frequency === "Monthly" || formik.values.frequency === "Every N Months") {
                        formik.setFieldTouched("day_of_month", true);
                        if (!formik.values.day_of_month) {
                          formik.setFieldError("day_of_month", "Day of the month is required");
                          hasErrors = true;
                        }
                      }

                      if (formik.values.frequency === "Weekly" || formik.values.frequency === "Every N Weeks") {
                        formik.setFieldTouched("weekday", true);
                        if (!formik.values.weekday) {
                          formik.setFieldError("weekday", "Weekday is required");
                          hasErrors = true;
                        }
                      }

                      if (formik.values.frequency === "Yearly") {
                        formik.setFieldTouched("day_of_year", true);
                        formik.setFieldTouched("month", true);
                        if (!formik.values.day_of_year) {
                          formik.setFieldError("day_of_year", "Day of year is required");
                          hasErrors = true;
                        }
                        if (!formik.values.month) {
                          formik.setFieldError("month", "Month is required");
                          hasErrors = true;
                        }
                      }

                      if (formik.values.frequency === "Quarterly") {
                        formik.setFieldTouched("days_after_quarter", true);
                        if (formik.values.days_after_quarter === "" || formik.values.days_after_quarter === null || formik.values.days_after_quarter === undefined) {
                          formik.setFieldError("days_after_quarter", "Days after quarter is required");
                          hasErrors = true;
                        }
                      }
                      if (hasErrors) {
                        return;
                      }
                      formik.handleSubmit();
                    }}
                    style={{
                      fontSize: "16px",
                    }}
                    disabled={submitloading || (recurringChargeId && !hasFormChanges())}
                  >
                    {submitloading ? (
                      <WhiteLoaderComponent
                        height="20"
                        width="20"
                        padding="20"
                        loader={loading}
                      />
                    ) : recurringChargeId ? (
                      "Update Recurring Donation"
                    ) : (
                      "Add Recurring Donation"
                    )}
                  </Button>
                </Grid>
              )}
            </Grid>
          </DialogContent>
        )}
      </Dialog>
      <AddCardDetailsForm
        onHide={() => setModalShow(false)}
        show={modalShow}
        CustomerId={CustomerId}
        fetchData={fetchRecurringCardData}
        CompanyId={CompanyId}
        Gateway={isDejavooGateway(cardGateway || tokenDecode?.Gateway)
          ? "DEJAVOO"
          : cardGateway || tokenDecode?.Gateway}
      />
      <AddAccountDialog
        open={addBankAccountDialogOpen}
        onClose={() => setAddBankAccountDialogOpen(false)}
        onSuccess={() => {
          fetchAccounts();
          setAddBankAccountDialogOpen(false);
        }}
        CompanyId={CompanyId}
      />
    </>
  );
};

// Add Account Dialog Component
const AddAccountDialog = ({ open, onClose, onSuccess, CompanyId }) => {
  const [accountName, setAccountName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (!accountName || accountName.trim() === "") {
      setError("Account name is required");
      return;
    }

    setError("");
    setLoading(true);
    try {
      const res = await AxiosInstance.post("/v1/account", {
        account_name: accountName.trim(),
        account_type: "Asset",
        CompanyId: CompanyId,
      });

      if (res?.status === 200 || res?.data?.statusCode === 200) {
        showToast.success("Account added successfully");
        setAccountName("");
        setError("");
        onSuccess();
      } else {
        setError(res?.data?.message || "Failed to add account");
        showToast.error(res?.data?.message || "Failed to add account");
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to add account. Please try again.";
      setError(errorMessage);
      showToast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setAccountName("");
    setError("");
    onClose();
  };

  const isDisabled = loading || !accountName || accountName.trim() === "";

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "8px",
        },
      }}
    >
      <DialogTitle
        sx={{
          color: "#0f2b46",
          fontWeight: 600,
          fontSize: "1.25rem",
          padding: "24px 24px 16px 24px",
        }}
      >
        Add Account
      </DialogTitle>
      
      <DialogContent sx={{ padding: "0 24px 16px 24px" }}>
        <InputText
          fullWidth
          label="Account Name *"
          value={accountName}
          onChange={(e) => {
            setAccountName(e.target.value);
            if (error) setError("");
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !isDisabled) {
              handleSubmit();
            }
          }}
          placeholder="Enter account name"
          error={!!error}
          helperText={error}
          className="mb-2 mt-2"
          autoFocus
        />
        <Typography
          variant="body2"
          sx={{
            color: "#666",
            fontSize: "0.875rem",
            marginTop: "8px",
          }}
        >
          Account type will be set to "Asset" automatically.
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ padding: "16px 24px 24px 24px", gap: 2 }}>
        <MuiButton
          onClick={handleClose}
          disabled={loading}
          sx={{
            color: "#0f2b46",
            textTransform: "none",
            padding: "8px 16px",
          }}
        >
          Cancel
        </MuiButton>
        <MuiButton
          onClick={handleSubmit}
          disabled={isDisabled}
          variant="contained"
          sx={{
            backgroundColor: "#0f2b46",
            textTransform: "none",
            padding: "8px 24px",
            "&:hover": {
              backgroundColor: "#0f2b46",
            },
            "&:disabled": {
              backgroundColor: "#e0e0e0",
              color: "var(--text-muted)",
            },
          }}
        >
          {loading ? "Adding..." : "Add Account"}
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
};

export default RecurringPayments;
